export default __webpack_public_path__ + "static/media/i207jk.faa834be.webp";